import { render, staticRenderFns } from "./PieChartComponent.vue?vue&type=template&id=7034599e"
import script from "./PieChartComponent.vue?vue&type=script&lang=js"
export * from "./PieChartComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports